import { Container, Title } from '@/components/Package'
import { PassList } from '@/components/Package/PassList'
import { usePassTab } from '@/components/Package/hooks/usePassTab'
import { Segment } from '@/components/common/Segment'
import { LoginDialogWithStore } from '@/components/modal/LoginDialogWithStore'
import { mixpanelEvent } from '@/lib/mixpanels/mixpanel'
import { MYPAGE_PASSES } from '@/settings/constant'
import { ConfirmDialog } from '@bookips/solvook-ui-library'
import { Row } from 'antd'
import { NextComponentType } from 'next'
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'
import styled from 'styled-components'
import { UseTicketProductInfo } from '../../api/membership'
import usePassStore from 'src/store/pass'
import useSearchParams from '@/hooks/useSearchParams'
import { REDIRECT_QUERY } from '@/hooks/useRedirect'
import Notice from '@/components/Package/SubscribeToPass/SubscribeNotice'

export interface MembershipPageProps {}

export interface IGroupByCategoryData {
	categoryTitle: string
	passProduct: UseTicketProductInfo[]
}

const MembershipPage: NextComponentType<MembershipPageProps> = ({}) => {
	const { push, query } = useRouter()
	const searchParam = useSearchParams()
	const [isOpenSubscribeWarningDialog, setIsOpenSubscribeWarningDialog] = useState(false)

	const { passTabOptions, groupBySubjectData, handlePassTab, subject, passCategory } =
		usePassTab()

	const { setRedirectPath } = usePassStore((state) => ({
		setRedirectPath: state.setRedirectPath,
	}))

	const handleSubscribeWarningDialog = () => {
		setIsOpenSubscribeWarningDialog((prev) => !prev)
	}

	// 엑스퍼트에서 넘어온 경우를 위해 redirect 저장을 합니다.
	useEffect(() => {
		if (searchParam.get(REDIRECT_QUERY)) {
			setRedirectPath(searchParam.get(REDIRECT_QUERY))
		}
	}, [searchParam])
	return (
		<MembershipPageLayout>
			<MembershipContainer>
				<Title>이용권 구매</Title>
				<Row>
					<PassListContainer>
						<Container>
							<Segment
								onChange={handlePassTab}
								value={passCategory}
								options={passTabOptions}
								onResize={() => {}} //타입에러로 인한추가
								onResizeCapture={() => {}} //타입에러로 인한추가
							/>
						</Container>
						{groupBySubjectData && (
							<PassList
								data={groupBySubjectData}
								handleSubscribeWarningDialog={handleSubscribeWarningDialog}
							/>
						)}
					</PassListContainer>
				</Row>
				<Notice
					title={'유의사항'}
					caution={passNoticeList}
					layoutStyle={{ maxHeight: 'unset' }}
				/>
			</MembershipContainer>

			<LoginDialogWithStore />
			<ConfirmDialog
				open={isOpenSubscribeWarningDialog}
				onClose={() => handleSubscribeWarningDialog()}
				title="이미 구독중인 상품이에요."
				content={"상품의 구독정보를 보고 싶으시다면 '이용권 관리 가기'를 눌러주세요."}
				onCancel={() => {
					// mx-9
					mixpanelEvent('Popup Button Clicked', {
						'Popup Type': 'Already Subscribed',
						'Popup Title': '이미 구독중인 상품이에요',
						'Button Name': '이용권 관리 가기',
						'Button URL': MYPAGE_PASSES,
					})
					handleSubscribeWarningDialog()
					push(MYPAGE_PASSES)
				}}
				cancelText="이용권 관리 가기"
				onOk={() => {
					handleSubscribeWarningDialog()
					// mx-9
					mixpanelEvent('Popup Button Clicked', {
						'Popup Type': 'Already Subscribed',
						'Popup Title': '이미 구독중인 상품이에요',
						'Button Name': '확인',
						'Button URL': null,
					})
				}}
				okText="확인"
			/>
		</MembershipPageLayout>
	)
}
export default MembershipPage

const MembershipPageLayout = styled.div`
	background-color: ${(props) => props.theme.new.colors.sol_gray_0};
	width: 100%;
	height: 100%;
	min-height: calc(100vh - 75px);

	@media (max-width: 768px) {
		height: 100%;
	}
`

const MembershipContainer = styled.div`
	max-width: 720px;
	margin: 0 auto;
	padding-top: 56px;

	@media (max-width: 768px) {
		padding: 40px 16px 0 16px;
	}
`
const PassListContainer = styled.div`
	width: 100%;
`
const passNoticeList = [
	'이용권을 사용하여 수업자료 구매 시 이용권별 유효기간 내 이용할 수 있습니다.',
	'수업자료는 쏠북 전용 뷰어에서 열람 및 출력할 수 있습니다.',
	'수업자료는 파일로 제공되지 않고 다운로드할 수 없습니다.',
	'이용권 이용 및 환불은 이용권 상품별로 상이하오니 구매 전 이용권 상품별 상세 내용에서 이용 범위 및 환불 조건을 확인하세요.',
	'이용권 상품별 상세 내용은 이용권 상품 > 자세히 보기 버튼을 눌러 확인할 수 있습니다.',
]
